var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view == 'generales')?_c('div',{staticClass:"p-b-100"},[(!_vm.loading)?_c('div',[_c('icon-cards')],1):_c('div',{staticClass:"all-center"},[_c('b-spinner',{attrs:{"variant":"primary"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }